<template>
  <div class="com-product-mobile">
    <img class="bg" :src="sjbk2" alt="">
    <img class="img" :src="img" alt="">
  </div>
</template>

<script>
  /**
   * @Class: components
   * @Module: com-product-mobile
   * @Description: 组件 -产品 -手机端
   * @Version: 1.0.0
   ---- Created by "Sitdown.liu<731225377@qq.com>" on "2020/4/28 20:19" ---*/
  import sjbk2 from '@/assets/img/content/sjbk2.png';

  export default {
    props: ["img"],
    name: "com-product-mobile",
    data() {
      return {
        sjbk2
      }
    },
  }
</script>

<style lang="less">
  .com-product-mobile {
    width: 100%;
    height: 550px;
    position: relative;

    .bg {
      width: 100%;
      height: 100%;
    }

    .img {
      width: 82%;
      height: 70%;
      position: absolute;
      top: 15%;
      left: 9%;
      border: 1px solid #dddddd;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/com-product-mobile.vue